import { Star, StarHalf } from "lucide-react";
import { Testimonial } from "../lib/types";

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <div className="flex gap-4 items-center mb-4">
        <div className="w-14 h-14 bg-neutral-100 rounded-full overflow-hidden">
          <img 
            src={testimonial.imageUrl} 
            alt={`${testimonial.name} portrait`} 
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <h4 className="font-semibold font-heading">{testimonial.name}</h4>
          <p className="text-sm text-neutral-700">{testimonial.title}</p>
        </div>
      </div>
      <p className="text-neutral-700 mb-4">{testimonial.comment}</p>
      <div className="flex text-accent">
        {[...Array(Math.floor(testimonial.rating))].map((_, i) => (
          <Star key={i} className="fill-current" />
        ))}
        {testimonial.rating % 1 !== 0 && <StarHalf className="fill-current" />}
      </div>
    </div>
  );
};

interface TestimonialSectionProps {
  testimonials: Testimonial[];
}

const TestimonialSection = ({ testimonials }: TestimonialSectionProps) => {
  return (
    <section className="py-20 bg-primary">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="text-accent font-medium">Testimonials</span>
          <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-4 text-white font-heading">
            What Farmers Say About Us
          </h2>
          <p className="text-white text-opacity-90">
            Hear from farmers who have experienced success with our seed varieties.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
